// extracted by mini-css-extract-plugin
export var dividerContainer = "_9l-0";
export var line = "_9l-1";